/*
 * Route error boundary: a render crash or a failed lazy chunk. 404 responses thrown from loaders show the
 * 404 page; anything else shows a calm crash page with reload, and the error in dev.
 */
import { ArrowClockwise } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { isRouteErrorResponse, useRouteError } from 'react-router'
import { Button } from '@/components/ui'
import { isDev } from '@/lib/env'
import { useDocumentTitle } from '@/lib/useDocumentTitle'
import { NotFoundPage } from './NotFoundPage'
import { SystemFrame } from './SystemFrame'

export function RouteError() {
  const error = useRouteError()
  const { t } = useTranslation('errors')
  useDocumentTitle(t('crash.title'))
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />
  const message = error instanceof Error ? `${error.name}: ${error.message}` : String(error)
  return (
    <SystemFrame>
      <h1 className="display text-28 sm:text-32">{t('crash.title')}</h1>
      <p className="mt-3 max-w-md text-15 leading-7 text-muted">{t('crash.body')}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-2">
        <Button icon={<ArrowClockwise />} onClick={() => window.location.reload()}>
          {t('crash.reload')}
        </Button>
        <Button variant="secondary" asChild>
          <a href="/">{t('crash.home')}</a>
        </Button>
      </div>
      {isDev ? (
        <pre className="mt-8 max-w-full overflow-auto rounded-xl bg-terminal p-4 text-start font-mono text-12 text-terminal-text ltr-island">
          {message}
        </pre>
      ) : null}
    </SystemFrame>
  )
}
